import React, { useState } from "react";
import Lists from "./Lists";
import Today from "./Today";

export default function MyNotes() {
  const [active, setActive] = useState("lists");

  // Define the style for the active button using the CSS variable
  const activeStyle = {
    backgroundColor: "var(--main-color)",
    color: "gray-800",
  };

  return (
    <>
      <div className="flex flex-col sm:flex-row sm:m-4 md:m-6">
        <div className="flex-1 flex flex-wrap items-center justify-center sm:justify-start mt-4 sm:mt-0">
          <button
            type="button"
            className={`${
              active === "today"
                ? "text-gray-800"
                : "bg-white text-black border border-gray-300"
            } focus:outline-none  focus:ring-4 focus:ring-gray-100 font-medium rounded-md text-md px-5 py-2.5 mx-2 mb-2`}
            style={active === "today" ? activeStyle : {}}
            onClick={() => setActive("today")}
          >
            Today
          </button>
          <button
            type="button"
            className={`${
              active === "lists"
                ? "text-gray-800"
                : "bg-white text-black border border-gray-300"
            } focus:outline-none  focus:ring-4 focus:ring-gray-100 font-medium rounded-md text-md px-5 py-2.5 mx-2 mb-2`}
            style={active === "lists" ? activeStyle : {}}
            onClick={() => setActive("lists")}
          >
            Lists
          </button>
        </div>
      </div>
      <div className="flex-1 mt-4 sm:mt-6">
        {active === "lists" && <Lists />}
        {active === "today" && <Today />}
      </div>
    </>
  );
}
